function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18 12.5454C18 15.8591 15.3137 18.5454 12 18.5454C8.68629 18.5454 6 15.8591 6 12.5454",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 18.6364V22",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3636 22L9.81819 22",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 8.75,
  y: 2.75,
  width: 6.5,
  height: 12.5,
  rx: 3.25,
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgMicrophone = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicrophone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Microphone.d621408c.svg";
export { ForwardRef as ReactComponent };